const cardetails = {
    en: {
        "cd.notFound": "Vehicle not found",

        "cd.vin": "VIN",
        "cd.lotStock": "Lot/Stock",
        "cd.noImages": "No images uploaded yet",
        "cd.downloadAll": "Download all",

        // badges
        "cd.fullyPaid": "Fully paid",
        "cd.partiallyPaid": "Partially paid",
        "cd.unpaid": "Unpaid",
        "cd.green": "Green",

        // section titles
        "cd.financials": "Financials",
        "cd.shippingJourney": "Shipping journey",
        "cd.vehicle": "Vehicle",
        "cd.shippingContainer": "Shipping & container",
        "cd.receiverDriver": "Receiver & driver",
        "cd.notes": "Notes",

        // timeline
        "cd.purchased": "Purchased",
        "cd.atWarehouse": "At warehouse",
        "cd.pickedUp": "Picked up",
        "cd.containerLoaded": "Container loaded",
        "cd.arrivedAtPort": "Arrived at port",
        "cd.containerOpened": "Container opened",
        "cd.pending": "Pending",

        // financial labels
        "cd.paid": "Paid",
        "cd.remaining": "Remaining",
        "cd.pctPaid": "% paid",
        "cd.total": "Total",
        "cd.auctionPrice": "Auction price",
        "cd.transportation": "Transportation",
        "cd.dealerFee": "Dealer fee",
        "cd.containerCost": "Container cost",
        "cd.landingCost": "Landing cost",
        "cd.carAddOn": "Car add-on",
        "cd.transportAddOn": "Transport add-on",

        // vehicle info
        "cd.auction": "Auction",
        "cd.docType": "Document type",
        "cd.vehicleType": "Vehicle type",
        "cd.hybrid": "Hybrid",
        "cd.key": "Key",
        "cd.insured": "Insured",
        "cd.usState": "US state",
        "cd.usPort": "US port",

        // shipping & container
        "cd.line": "Line",
        "cd.containerNo": "Container #",
        "cd.booking": "Booking",
        "cd.boat": "Boat",
        "cd.terminal": "Terminal",
        "cd.destinationPort": "Destination port",
        "cd.loaded": "Loaded",
        "cd.opened": "Opened",
        "cd.titleReceived": "Title received",
        "cd.titleWarning": "Loaded into a container without the title!",
        "cd.titleMissing": "Title not received yet",
        "cd.costs": "Costs",
        "cd.cost_auction": "Auction",
        "cd.cost_transport": "Transport",
        "cd.cost_insurance": "Insurance",
        "cd.cost_service": "Service",
        "cd.cost_other": "Other",
        "cd.costTotal": "Total",
        "cd.costNone": "No cost entries yet",
        "cd.costAmount": "Amount",
        "cd.costDescription": "Description",
        "cd.costAdd": "Add",
        "cd.discounts": "Discounts",
        "cd.discount": "Discount",
        "cd.discountTotal": "Total discount",
        "cd.discountNone": "No discounts yet",
        "cd.discountAmount": "Amount",
        "cd.discountReason": "Reason",
        "cd.discountAdd": "Apply",
        "cd.customsFine": "Customs clearance fine",
        "cd.customsFrozen": "frozen (cleared)",
        "cd.customsOverdue": "Days overdue",
        "cd.customsDeadline": "Deadline",
        "cd.customsRate": "Rate",
        "cd.perDay": "day",
        "cd.customsWaive": "Waive",
        "cd.timeline": "Shipping timeline",
        "cd.stage_auction": "Auction won",
        "cd.stage_pickup": "Picked up (US)",
        "cd.stage_warehouse": "US warehouse",
        "cd.stage_loaded": "Container loaded",
        "cd.stage_transit": "In transit",
        "cd.stage_arrived": "Arrived (Poti)",
        "cd.stage_opened": "Container opened",
        "cd.stage_cleared": "Customs cleared",

        // receiver & driver
        "cd.buyer": "Buyer",
        "cd.receiver": "Receiver",
        "cd.receiverId": "Receiver ID",
        "cd.receiverPhone": "Receiver phone",
        "cd.driver": "Driver",
        "cd.driverPhone": "Driver phone",
        "cd.driverCompany": "Driver company",
        "cd.towPlate": "Tow plate",
    },
    ru: {
        "cd.notFound": "Автомобиль не найден",

        "cd.vin": "VIN",
        "cd.lotStock": "Лот/Сток",
        "cd.noImages": "Изображения ещё не загружены",
        "cd.downloadAll": "Скачать всё",

        "cd.fullyPaid": "Полностью оплачено",
        "cd.partiallyPaid": "Частично оплачено",
        "cd.unpaid": "Не оплачено",
        "cd.green": "Зелёный",

        "cd.financials": "Финансы",
        "cd.shippingJourney": "Путь доставки",
        "cd.vehicle": "Автомобиль",
        "cd.shippingContainer": "Доставка и контейнер",
        "cd.receiverDriver": "Получатель и водитель",
        "cd.notes": "Заметки",

        "cd.purchased": "Куплено",
        "cd.atWarehouse": "На складе",
        "cd.pickedUp": "Забрано",
        "cd.containerLoaded": "Контейнер загружен",
        "cd.arrivedAtPort": "Прибыло в порт",
        "cd.containerOpened": "Контейнер открыт",
        "cd.pending": "Ожидается",

        "cd.paid": "Оплачено",
        "cd.remaining": "Остаток",
        "cd.pctPaid": "% оплачено",
        "cd.total": "Итого",
        "cd.auctionPrice": "Цена аукциона",
        "cd.transportation": "Транспортировка",
        "cd.dealerFee": "Комиссия дилера",
        "cd.containerCost": "Стоимость контейнера",
        "cd.landingCost": "Стоимость растаможки",
        "cd.carAddOn": "Доплата за авто",
        "cd.transportAddOn": "Доплата за транспортировку",

        "cd.auction": "Аукцион",
        "cd.docType": "Тип документа",
        "cd.vehicleType": "Тип автомобиля",
        "cd.hybrid": "Гибрид",
        "cd.key": "Ключ",
        "cd.insured": "Застраховано",
        "cd.usState": "Штат США",
        "cd.usPort": "Порт США",

        "cd.line": "Линия",
        "cd.containerNo": "Контейнер №",
        "cd.booking": "Букинг",
        "cd.boat": "Судно",
        "cd.terminal": "Терминал",
        "cd.destinationPort": "Порт назначения",
        "cd.loaded": "Загружено",
        "cd.opened": "Открыто",
        "cd.titleReceived": "Тайтл получен",
        "cd.titleWarning": "Загружен в контейнер без тайтла!",
        "cd.titleMissing": "Тайтл ещё не получен",
        "cd.costs": "Расходы",
        "cd.cost_auction": "Аукцион",
        "cd.cost_transport": "Транспорт",
        "cd.cost_insurance": "Страховка",
        "cd.cost_service": "Сервис",
        "cd.cost_other": "Другое",
        "cd.costTotal": "Итого",
        "cd.costNone": "Пока нет записей о расходах",
        "cd.costAmount": "Сумма",
        "cd.costDescription": "Описание",
        "cd.costAdd": "Добавить",
        "cd.discounts": "Скидки",
        "cd.discount": "Скидка",
        "cd.discountTotal": "Всего скидок",
        "cd.discountNone": "Скидок пока нет",
        "cd.discountAmount": "Сумма",
        "cd.discountReason": "Причина",
        "cd.discountAdd": "Применить",
        "cd.customsFine": "Штраф за растаможку",
        "cd.customsFrozen": "заморожен (растаможен)",
        "cd.customsOverdue": "Дней просрочки",
        "cd.customsDeadline": "Срок",
        "cd.customsRate": "Ставка",
        "cd.perDay": "день",
        "cd.customsWaive": "Отменить",
        "cd.timeline": "Хронология доставки",
        "cd.stage_auction": "Выигран на аукционе",
        "cd.stage_pickup": "Забран (США)",
        "cd.stage_warehouse": "Склад в США",
        "cd.stage_loaded": "Загружен в контейнер",
        "cd.stage_transit": "В пути",
        "cd.stage_arrived": "Прибыл (Поти)",
        "cd.stage_opened": "Контейнер открыт",
        "cd.stage_cleared": "Растаможен",

        "cd.buyer": "Покупатель",
        "cd.receiver": "Получатель",
        "cd.receiverId": "ID получателя",
        "cd.receiverPhone": "Телефон получателя",
        "cd.driver": "Водитель",
        "cd.driverPhone": "Телефон водителя",
        "cd.driverCompany": "Компания водителя",
        "cd.towPlate": "Номер эвакуатора",
    },
    geo: {
        "cd.notFound": "ავტომობილი ვერ მოიძებნა",

        "cd.vin": "VIN",
        "cd.lotStock": "ლოტი/სტოკი",
        "cd.noImages": "სურათები ჯერ არ არის ატვირთული",
        "cd.downloadAll": "ყველას ჩამოტვირთვა",

        "cd.fullyPaid": "სრულად გადახდილი",
        "cd.partiallyPaid": "ნაწილობრივ გადახდილი",
        "cd.unpaid": "გადაუხდელი",
        "cd.green": "მწვანე",

        "cd.financials": "ფინანსები",
        "cd.shippingJourney": "მიწოდების მარშრუტი",
        "cd.vehicle": "ავტომობილი",
        "cd.shippingContainer": "მიწოდება და კონტეინერი",
        "cd.receiverDriver": "მიმღები და მძღოლი",
        "cd.notes": "შენიშვნები",

        "cd.purchased": "შეძენილი",
        "cd.atWarehouse": "საწყობში",
        "cd.pickedUp": "აყვანილი",
        "cd.containerLoaded": "კონტეინერი დატვირთულია",
        "cd.arrivedAtPort": "ჩამოსული პორტში",
        "cd.containerOpened": "კონტეინერი გახსნილია",
        "cd.pending": "მოლოდინში",

        "cd.paid": "გადახდილი",
        "cd.remaining": "დარჩენილი",
        "cd.pctPaid": "% გადახდილი",
        "cd.total": "სულ",
        "cd.auctionPrice": "აუქციონის ფასი",
        "cd.transportation": "ტრანსპორტირება",
        "cd.dealerFee": "დილერის საკომისიო",
        "cd.containerCost": "კონტეინერის ღირებულება",
        "cd.landingCost": "განბაჟების ღირებულება",
        "cd.carAddOn": "დამატება ავტომობილზე",
        "cd.transportAddOn": "დამატება ტრანსპორტირებაზე",

        "cd.auction": "აუქციონი",
        "cd.docType": "დოკუმენტის ტიპი",
        "cd.vehicleType": "ავტომობილის ტიპი",
        "cd.hybrid": "ჰიბრიდი",
        "cd.key": "გასაღები",
        "cd.insured": "დაზღვეული",
        "cd.usState": "აშშ შტატი",
        "cd.usPort": "აშშ პორტი",

        "cd.line": "ხაზი",
        "cd.containerNo": "კონტეინერი №",
        "cd.booking": "ჯავშანი",
        "cd.boat": "გემი",
        "cd.terminal": "ტერმინალი",
        "cd.destinationPort": "დანიშნულების პორტი",
        "cd.loaded": "დატვირთული",
        "cd.opened": "გახსნილი",
        "cd.titleReceived": "საბუთი (Title) მისულია",
        "cd.titleWarning": "ჩატვირთულია კონტეინერში საბუთის გარეშე!",
        "cd.titleMissing": "საბუთი ჯერ არ მისულა",
        "cd.costs": "ხარჯები",
        "cd.cost_auction": "აუქციონი",
        "cd.cost_transport": "ტრანსპორტი",
        "cd.cost_insurance": "დაზღვევა",
        "cd.cost_service": "სერვისი",
        "cd.cost_other": "სხვა",
        "cd.costTotal": "სულ",
        "cd.costNone": "ხარჯები ჯერ არ არის",
        "cd.costAmount": "თანხა",
        "cd.costDescription": "აღწერა",
        "cd.costAdd": "დამატება",
        "cd.discounts": "ფასდაკლებები",
        "cd.discount": "ფასდაკლება",
        "cd.discountTotal": "ჯამური ფასდაკლება",
        "cd.discountNone": "ფასდაკლება ჯერ არ არის",
        "cd.discountAmount": "თანხა",
        "cd.discountReason": "მიზეზი",
        "cd.discountAdd": "გამოყენება",
        "cd.customsFine": "განბაჟების დაგვიანების ჯარიმა",
        "cd.customsFrozen": "გაყინული (განბაჟებული)",
        "cd.customsOverdue": "ვადაგადაცილების დღეები",
        "cd.customsDeadline": "ვადა",
        "cd.customsRate": "განაკვეთი",
        "cd.perDay": "დღე",
        "cd.customsWaive": "გაუქმება",
        "cd.timeline": "მიწოდების ეტაპები",
        "cd.stage_auction": "აუქციონზე მოგებული",
        "cd.stage_pickup": "აყვანილი (აშშ)",
        "cd.stage_warehouse": "აშშ-ის საწყობი",
        "cd.stage_loaded": "კონტეინერში ჩატვირთული",
        "cd.stage_transit": "გზაშია",
        "cd.stage_arrived": "ჩამოსული (ფოთი)",
        "cd.stage_opened": "კონტეინერი გახსნილი",
        "cd.stage_cleared": "განბაჟებული",

        "cd.buyer": "მყიდველი",
        "cd.receiver": "მიმღები",
        "cd.receiverId": "მიმღების ID",
        "cd.receiverPhone": "მიმღების ტელეფონი",
        "cd.driver": "მძღოლი",
        "cd.driverPhone": "მძღოლის ტელეფონი",
        "cd.driverCompany": "მძღოლის კომპანია",
        "cd.towPlate": "ევაკუატორის ნომერი",
    },
};

export default cardetails;
